import EvaporatorTableSKU from './EvaporatorTableSKU';

export default EvaporatorTableSKU;
